
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export function BlcNotificationOne(){
   const notify = ()=>(toast.success('Thank you very much for reservation service, we will contact with you very soon', {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    }));

   //'Thank you very much for reservation service, we will contact with you very soon'


   return(
       <>
       {
           notify() && <ToastContainer position="top-center"
           autoClose={8000}
           hideProgressBar={false}
           newestOnTop={false}
           closeOnClick
           rtl={false}
           pauseOnFocusLoss
           draggable
           pauseOnHover/>
       }
      
       </>
   )
   
}





export function BlcNotificationTwo(){
    const notify = ()=>(toast.error('An error Occured, Please try later.', {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        }));
       //An error Occured, Please try later.

    return(
        <>
        {
            notify() &&
           <ToastContainer/>
        }
        
        </>
    )
}

